import React from "react";
import { observer } from "mobx-react";
import { ImgVideoPlaceholder } from "@images/ImgVideoPlaceholder";

export type VideoGenModel = 'Wan2.2' | 'MiniMaxH3';

type VideoModelPickerProps = {
  model: VideoGenModel;
  onSelect: (model: VideoGenModel) => void;
};

const VIDEO_MODELS: { value: VideoGenModel; displayName: string; previewSrc?: string }[] = [
  { value: 'Wan2.2', displayName: 'Wan 2.2 14b', previewSrc: '/img/models/wan2_2.jpg' },
  { value: 'MiniMaxH3', displayName: 'MiniMax H3', previewSrc: '/img/models/minimax_h3.jpg' },
];

/** Placeholder icon shown when model preview image is missing */
const VideoModelPlaceholder = () => <ImgVideoPlaceholder />;

@observer
class VideoModelPicker extends React.Component<VideoModelPickerProps> {
  render() {
    const { model, onSelect } = this.props;

    return (
      <div className="image-model-selector video-model-selector">
        {VIDEO_MODELS.map((m) => (
          <div key={m.value} className="model-btn-wrapper">
            <button
              className={'model-btn' + (model === m.value ? ' active' : '')}
              onClick={() => onSelect(m.value)}
              title={m.displayName}
            >
              {m.previewSrc
                ? <img
                    className="model-preview"
                    src={m.previewSrc}
                    alt={m.displayName}
                    onError={(e) => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
                  />
                : <VideoModelPlaceholder />
              }
              <div className="model-name-row">
                <span>{m.displayName}</span>
              </div>
            </button>
          </div>
        ))}
      </div>
    );
  }
}

export default VideoModelPicker;
